import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import LoginPage from "./pages/LoginPage.jsx";
import ResetPasswordPage from "./pages/ResetPasswordPage.jsx";
import ForgotPasswordPage from "./pages/ForgotPasswordPage.jsx";
import RegisterPage from "./pages/RegisterPage.jsx";
import AdminLayout from "./layouts/Admin";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import ConfirmRegistrationPage from "./pages/ConfirmRegistrationPage.jsx";
import routes from "./routes.js";

function ProtectedRoute({ component: Component, ...rest }) {
    const { isAuthenticated, isGuest } = useAuth();

    const normalizePath = (path) => {
        if (!path) return "/";
        const normalized = path.replace(/\/+$/, "");
        return normalized || "/";
    };

    const guestAllowedPaths = routes
        .filter((route) => route.guestAllowed)
        .map((route) => normalizePath(`${route.layout}${route.path}`));

    const isGuestAllowedPath = (pathname) => {
        const currentPath = normalizePath(pathname);

        return guestAllowedPaths.some((allowedPath) => {
            return (
                currentPath === allowedPath ||
                currentPath.startsWith(allowedPath + "/")
            );
        });
    };

    return (
        <Route
            {...rest}
            render={(props) => {
                const currentPath = normalizePath(props.location.pathname);
                const isAllowedForGuest = isGuestAllowedPath(currentPath);

                if (!isAuthenticated) {
                    if (currentPath === "/admin") {
                        return <Redirect to="/admin/aktiennews" />;
                    }

                    if (isAllowedForGuest) {
                        return <Component {...props} />;
                    }

                    return <Redirect to="/login" />;
                }

                if (isGuest) {
                    if (currentPath === "/admin") {
                        return <Redirect to="/admin/aktiennews" />;
                    }

                    if (!isAllowedForGuest) {
                        return <Redirect to="/admin/aktiennews" />;
                    }
                }

                return <Component {...props} />;
            }}
        />
    );
}

export default function App() {
    useEffect(() => {
        document.title = `K.I.M.A.T. V${process.env.REACT_APP_VERSION || "?"}`;
    }, []);

    return (
        <AuthProvider>
            <Switch>
                <Route exact path="/login" component={LoginPage} />
                <Route exact path="/forgot-password" component={ForgotPasswordPage} />
                <Route exact path="/reset-password" component={ResetPasswordPage} />
                <Route exact path="/register" component={RegisterPage} />
                <Route
                    exact
                    path="/confirm-registration"
                    component={ConfirmRegistrationPage}
                />

                <ProtectedRoute path="/admin" component={AdminLayout} />

                <Redirect exact from="/" to="/login" />

                <Route>
                    <div style={{ padding: 40 }}>404 � Seite nicht gefunden</div>
                </Route>
            </Switch>
        </AuthProvider>
    );
}